export default {
  HYPOTHETICAL_AMORTIZATION: "d24774de-3d91-41f9-b21f-243d40c9bb34",
  ACTUAL_TRAILING_CASHFLOWS: "74be617e-8533-4337-be9b-b9a2fb108aaf",
  ACTUAL_PROJECTED_CASHFLOWS: "0c2d4c19-bd28-4205-86c3-683d87705df8",
  MOST_RECENT_PAYMENT: "74cc24ec-67de-4aa2-a7d4-fbcd4861482c",
  FROM_FILE: "cad4cf59-45ee-4854-bf59-e3c2b5656ab7",
  MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL: "dac4cf59-54cb-8454-ab26-a1b3b5656ab7"
};
